import { render, staticRenderFns } from "./IntersectionTypeList.vue?vue&type=template&id=cc19e6fa"
import script from "./IntersectionTypeList.vue?vue&type=script&lang=js"
export * from "./IntersectionTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports